module.exports = __webpack_public_path__ + "static/img/ab-news.d72948a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/abouts/ab-news.jpg
// module id = MTsY
// module chunks = 1